import { render, staticRenderFns } from "./RevisionIndiceValues.vue?vue&type=template&id=747d4e14&scoped=true"
import script from "./RevisionIndiceValues.vue?vue&type=script&lang=js"
export * from "./RevisionIndiceValues.vue?vue&type=script&lang=js"
import style0 from "./RevisionIndiceValues.vue?vue&type=style&index=0&id=747d4e14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747d4e14",
  null
  
)

export default component.exports